import { type AnyAction } from 'redux';
import {
	call,
	put,
	takeLatest,
	type CallEffect,
	type ForkEffect,
	type PutEffect,
} from 'redux-saga/effects';

import { TicketsActionType } from './enums';

import { handleEmptyNullValues, handleSortingValues } from '@utilities';
import { SORT_COLUMN_KEYS } from '@containers/approval/constants';
import { fetchAllTickets } from './api';

type TicketsSagaEffect = Generator<CallEffect<any> | PutEffect<any>>;
type TicketsSagaForEffect = Generator<ForkEffect<void>>;

const ticketsFiltersObject = (obj: Record<string, any>) => {
	const transformData = {
		filters: {
			...obj.filters,
			status: !!obj.filters.leadStatus?.length ? obj.filters.leadStatus.map(status => status.value) : [],
			// updatedOnStart: !!obj.filters.updatedOn?.length ? startOfDay(obj.filters?.updatedOn[0]).getTime() : null,
			// updatedOnEnd: !!obj.filters.updatedOn?.length ? endOfDay(obj.filters?.updatedOn[1]).getTime() : null,
			leadId: !!obj.filters.leadName?.length ? obj?.filters?.leadName[0]?.leadId : ''
		}
	};
	delete transformData?.filters?.leadName;
	delete transformData?.filters?.leadStatus;
	return {
		...obj,
		filters: transformData.filters
	};
};

export function* fetchAllTicketsEffect(action: AnyAction): TicketsSagaEffect {
	const { ticketsFilter, errorCB } = action.payload;
	let transformedFilters = handleSortingValues(ticketsFilter, SORT_COLUMN_KEYS);
	const transformedData = ticketsFiltersObject(transformedFilters);
	transformedFilters = handleEmptyNullValues(transformedData);

	try {
		const { data }: any = yield call(fetchAllTickets, handleEmptyNullValues(transformedFilters));
		const ticketsList = data.tickets;
		yield put({
			type: TicketsActionType.STORE_ALL_TICKETS,
			payload: { ticketsList, totalRecords: data.totalRecords }
		});
	} catch (error: unknown) {
		yield put({
			type: TicketsActionType.ERROR_ALL_TICKETS,
			payload: {
				error
			}
		});
		errorCB(error?.message);
	}
}

export function* fetchAllTicketsSaga(): TicketsSagaForEffect {
	yield takeLatest(TicketsActionType.FETCH_ALL_TICKETS, fetchAllTicketsEffect);
}
